// hooks/useSocket.js
import { useEffect, useRef } from "react";
import { io } from "socket.io-client";

import { debugLog } from "../utils/debugUtils";

export default function useSocket() {
	const socketRef = useRef();

	useEffect(() => {
		const url =
			process.env.NODE_ENV === "development"
				? "http://localhost:8080"
				: process.env.REACT_APP_SERVER_URI;
		debugLog(2, "[useSocket][FLOW] socket init started", { url: url });
		// The server binds bid actions to the authenticated HTTP session.
		const socket = io(url, { withCredentials: true });
		socketRef.current = socket;

		socket.on("connect", () => {
			debugLog(2, "[useSocket][FLOW] connected", { socketId: socket.id });
		});

		return () => {
			debugLog(2, "[useSocket][FLOW] disconnected", { socketId: socket.id });
			socket.disconnect();
		};
	}, []);

	return socketRef;
}
